import axios from "axios";

export const publicAxiosInstance = axios.create();
